import { useEffect, useState } from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useBannerComunidadPublic } from "../../hooks/UseBanner";



export const BannerHome = () => {
  const [active, setActive] = useState(0);
  const {
  banner: bannerData,
  loading,
  error,
} = useBannerComunidadPublic();

const banner = bannerData ?? [];
  const backendURL =
    process.env.REACT_APP_BACKEND_URL;
    


 
  useEffect(() => {
  if (!banner.length) return;

  const interval = setInterval(() => {
    setActive((prev) => (prev + 1) % banner.length);
  }, 6000);

  return () => clearInterval(interval);
}, [banner]);

   if (loading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: {
            xs: "70vh",
            md: "92vh",
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography>Cargando...</Typography>
      </Box>
    );
  }

  if (error) {
    return null;
  } 

  if (!banner.length) {
    return null;
  }


  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: {
          xs: "70vh",
          md: "92vh",
        },
        overflow: "hidden",
      }}
    >
      {banner.map((item, index) => (
        <Box
          key={item.id ?? index}
          sx={{
            position: "absolute",
            inset: 0,
            opacity: active === index ? 1 : 0,
            transition: "opacity 1.5s ease",
            zIndex: active === index ? 2 : 1,
          }}
        >
          {/* Imagen */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${backendURL}/${item.imagen})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transform:
                active === index ? "scale(1.08)" : "scale(1)",
              transition: "transform 8s ease",
            }}
          />

          {/* Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "rgba(72, 74, 117, 0.66)",
            }}
          />

          {/* Contenido */}
          <Container
            maxWidth="lg"
            sx={{
              position: "relative",
              zIndex: 5,
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              flexDirection: "column",
              color: "#fff",
            }}
          >
            {/* Título */}
            <Typography
              sx={{
                fontSize: {
                  xs: "2rem",
                  sm: "2.8rem",
                  md: "3.8rem",
                  lg: "4.6rem",
                },
                fontWeight: 700,
                letterSpacing: {
                  xs: 0.5,
                  md: 1,
                },
                lineHeight: 1.2,
                textAlign: "center",
                px: { xs: 2, sm: 4 },
                mb: 2,
                animation:
                  active === index
                    ? "fadeUp .9s ease forwards"
                    : "none",
              }}
            >
              {item.titulo}
            </Typography>

            {/* Descripción */}
            <Typography
              sx={{
                whiteSpace: "pre-line",
                fontSize: {
                  xs: ".95rem",
                  sm: "1.1rem",
                  md: "1.25rem",
                  lg: "1.45rem",
                },
                maxWidth: {
                  xs: "95%",
                  sm: "85%",
                  md: "820px",
                },
                lineHeight: {
                  xs: 1.7,
                  md: 1.9,
                },
                textAlign: "center",
                color: "rgba(255,255,255,.92)",
                px: { xs: 2, sm: 4 },
                mb: {
                  xs: 4,
                  md: 5,
                },
                animation:
                  active === index
                    ? "fadeUp 1.2s ease forwards"
                    : "none",
              }}
            >
              {item.descripcion}
            </Typography>

            {/* Botón */}
            {item.link && item.name_button && (
              <Button
                href={item.link}
                variant="contained"
                sx={{
                  px: {
                    xs: 3,
                    sm: 4,
                    md: 5,
                  },
                  py: {
                    xs: 1.2,
                    md: 1.6,
                  },
                  fontSize: {
                    xs: ".85rem",
                    sm: ".95rem",
                    md: "1rem",
                  },
                  textTransform: "uppercase",
                  borderRadius: "40px",
                  fontWeight: 600,
                  background: "#8f1515",
                  color: "#ffff",
                  boxShadow:
                    "0 12px 30px rgba(0,0,0,.25)",

                  "&:hover": {
                    color: "#ffff",
                    background: "#8f1515",
                    transform: "translateY(-3px)",
                  },

                  transition: ".35s",
                }}
              >
                {item.name_button}
              </Button>
            )}

            {/* Línea */}
            <Box
              key={`${index}-${active}`}
              sx={{
                position: "absolute",
                bottom: {
                  xs: 60,
                  sm: 80,
                  md: 120,
                  lg: 160,
                },
                width: {
                  xs: "75%",
                  sm: "82%",
                  md: "90%",
                  lg: "92%",
                },
                height: {
                  xs: "1px",
                  md: "2px",
                },
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,.95), transparent)",
                borderRadius: "50px",
                transformOrigin: "center",
                transform: "scaleX(0)",
                animation:
                  "growLine 1.5s ease forwards",

                "@keyframes growLine": {
                  from: {
                    transform: "scaleX(0)",
                    opacity: 0,
                  },
                  to: {
                    transform: "scaleX(1)",
                    opacity: 1,
                  },
                },
              }}
            />
          </Container>
        </Box>
      ))}


      <style>
        {`
          @keyframes fadeUp{
              from{
                opacity:0;
                transform:translateY(40px);
              }
              to{
                opacity:1;
                transform:translateY(0);
              }
          }
        `}
      </style>
    </Box>
  );
};